import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, roles }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  if (roles?.length) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!roles.includes(user?.role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
};

export default ProtectedRoute;
